'use strict';
import { sendBenefitSms } from '../api/users';
import util from '../util';
import $ from 'jquery';
import curry from 'lodash/curry';

const handleSendBenefit = curry((userId, $btn) => {
	const { benefitId } = $btn.closest('.lift').data();
	if (!benefitId) return;
	const $loader = util.addFormLoader($btn, {align: 'replace'});
	return sendBenefitSms(userId, benefitId)
		.then(() => $btn.addClass('btn-success').prop('disabled', true).html('<span class="is-icon is-icon-check-mark"></span> Etu lähetetty'))
		.catch(() => $btn.addClass('btn-error').prop('disabled', true).text('Edun lähetyksessä tapahtui virhe'))
		.finally(() => $loader.done());
});

export default API => {
	API.clubBenefits = (user) => {
		if (!user || !user.uuid) {
			return API.log('User object with uuid field required.');
		}

		$('.club-benefit-lifts').on('click', '.call-to-action', (e) => {
			e.preventDefault();
			const $btn = $(e.target);
			handleSendBenefit(user.uuid, $btn);
		});
	}
}
